import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  DeleteAllDevicesExceptCurrent,
  DeleteCurrentDevice,
  GetActiveDevices,
  SetActiveDevices,
  UserProfileTypes,
} from '@modules/user-profile/store/userProfile.action';
import { map, switchMap } from 'rxjs/operators';
import { HideSpinnerLoading } from '@modules/shared/store/common.actions';
import { DefaultService } from '@codegen/service';

@Injectable()
export class UserProfileEffects {
  private actions$ = inject(Actions);
  private userProfileResourceService = inject(DefaultService);

  public GetActiveDevices$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetActiveDevices>(UserProfileTypes.GetActiveDevices),
      switchMap(() => this.userProfileResourceService.deviceActive()),
      switchMap(data => {
        return [
          new SetActiveDevices(data.deviceList),
          new HideSpinnerLoading(),
        ];
      })
    )
  );

  public DeleteCurrentDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeleteCurrentDevice>(UserProfileTypes.DeleteCurrentDevice),
      map(data => data.payload),
      switchMap((deviceId: string) =>
        this.userProfileResourceService.deviceDelete({ deviceId })
      ),
      switchMap(() => [new GetActiveDevices()])
    )
  );

  public DeleteAllDevicesExceptCurrent$ = createEffect(() =>
    this.actions$.pipe(
      ofType<DeleteAllDevicesExceptCurrent>(
        UserProfileTypes.DeleteAllDevicesExceptCurrent
      ),
      switchMap(() => this.userProfileResourceService.deviceDeleteOthers({})),
      switchMap(() => [new GetActiveDevices()])
    )
  );
}
